import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const ServiceCard = ({ title, description, image, link, icon: Icon }) => {
  return (
    <motion.div 
      className="service-card group rounded-md"
      whileHover={{ y: -4 }}
      data-testid={`service-card-${link.split('/').pop()}`}
    >
      <Link to={link} className="block">
        <div className="aspect-[4/3] overflow-hidden">
          <img 
            src={image} 
            alt={title}
            className="service-card-image w-full h-full object-cover"
          />
        </div>
        <div className="p-6">
          <div className="flex items-center gap-3 mb-3">
            {Icon && <Icon className="w-6 h-6 text-orange" />}
            <h3 className="font-oswald uppercase text-xl font-bold text-navy group-hover:text-orange transition-colors">
              {title}
            </h3>
          </div>
          <p className="font-manrope text-slate-600 mb-4 line-clamp-2">
            {description}
          </p>
          <div className="flex items-center gap-2 text-orange font-oswald uppercase text-sm font-semibold">
            Learn More <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-2" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ServiceCard;
